module.exports = __webpack_public_path__ + "static/media/slide9.1048ffc5.png";